<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')" v-show="show">
      <div
        class="modal-container"
        @click="$emit('close')"
        :style="'width: ' + width"
      >
        <div class="modal-content" @click.stop>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    show: Boolean,
    width: {
      type: String,
      default: '800px'
    }
  },
  mounted() {
    document.addEventListener('keydown', e => {
      if (this.show && e.keyCode === 27) {
        this.$emit('close')
      }
    })
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}
.modal-container {
  height: 100%;
  max-width: 100%;
  margin: auto;
  overflow-y: auto;
  transition: all 0.3s ease;
}
@media screen and (min-width: 768px) {
  .modal-container:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
}
.modal-content {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue